module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-4.23fa7ab9.jpg";